/**
 * The integrations guide's sections, in reading order: the app renders and lists them, and the server keys each
 * reader's completion of them by these ids (`guide_progress`, docs/notes/app/integrations-guide.md).
 */
export const GUIDE_SECTIONS = [
  'authentication',
  'companies',
  'candidates',
  'test',
  'jobs',
  'matching',
  'reports',
  'sdk',
  'updates',
  'errors',
] as const
export type GuideSectionId = (typeof GUIDE_SECTIONS)[number]

/** Who set a section's completion: the guide, when the reader finished the section, or the reader, on its checkbox. */
export const GUIDE_PROGRESS_SOURCES = ['auto', 'manual'] as const
